import PropTypes from 'prop-types';
import { FunctionField, TextField, usePermissions, useRecordContext, useTranslate } from 'react-admin';
import { DetailsShow } from '@/components/global/drawers/DetailsShow.jsx';
import { DetailsActionsPopover } from '@/components/global/buttons/DetailsActionsPopover.jsx';
import CustomEditModalButton from '@/components/global/buttons/CustomEditModalButton.jsx';
import { StatusField } from '@/components/billOfMaterials/fields/StatusField.jsx';
import { useDrawer } from '@/composables/useDrawer.js';
import { canViewDetails } from '@/helpers/permissions/canViewDetails.js';

const BillOfMaterialsDetailsActions = () => {
    const record = useRecordContext();
    const translate = useTranslate();
    const { permissions } = usePermissions();
    const { openDrawer } = useDrawer();

    if (!permissions?.isAdmin || !record?.id) {
        return null;
    }

    return (
        <DetailsActionsPopover>
            <CustomEditModalButton label={translate('resources.billOfMaterials.labels.edit')} onOpen={() => openDrawer(record.id, 'spare-part-edit')} />
        </DetailsActionsPopover>
    );
};

export const BillOfMaterialsShow = ({ handleClose, elementId }) => {
    const translate = useTranslate();

    return (
        <DetailsShow
            handleClose={handleClose}
            elementId={elementId}
            resource='spare-part'
            canView={permissions => canViewDetails('spare-part', permissions)}
            actions={<BillOfMaterialsDetailsActions />}
            showChangeHistory
            historyFieldsSource='resources.billOfMaterials.labels'
        >
            <TextField source='name' label={translate('resources.billOfMaterials.labels.name')} />
            <TextField source='module' label={translate('resources.billOfMaterials.labels.module')} />
            <FunctionField label={translate('resources.billOfMaterials.labels.status')} render={record => <StatusField record={record} />} />
            <TextField source='useCount' label={translate('resources.billOfMaterials.labels.useCount')} />
        </DetailsShow>
    );
};

BillOfMaterialsShow.propTypes = {
    handleClose: PropTypes.func.isRequired,
    elementId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
